import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  Flex,
  Box,
  ModalFooter,
  FormLabel,
  Input
} from '@chakra-ui/react'
import { FC } from 'react'
import { BiSliderAlt } from 'react-icons/bi'
import { FiEdit2 } from 'react-icons/fi'
import { IoIosAddCircle } from 'react-icons/io'

import useParametrizationCurveStore from '@hook/parametrization/use-curve-store'

import Filter from '@component/Shared/Filter'
import SelectAsyncPaginateFromApiPost from '@component/Shared/FilterPaginationApiPost'

const ParametrizationCurveStoreCreate: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const {
    filterEdit,
    loadingEdit,
    selecteds,
    paramsEdit,
    handleUpdateEditParams,
    createData,
    clearForm,
    updateDataCurve
  } = useParametrizationCurveStore()
  return (
    <>
      {selecteds.length > 0 ? (
        <Button
          fontSize={14}
          size="sm"
          marginLeft={2}
          leftIcon={<FiEdit2 />}
          colorScheme="green"
          variant="outline"
          onClick={onOpen}
        >
          Editar
        </Button>
      ) : (
        <Button
          fontSize={14}
          size="sm"
          leftIcon={<IoIosAddCircle />}
          colorScheme="blue"
          variant="outline"
          onClick={onOpen}
        >
          Adicionar
        </Button>
      )}
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside"
        motionPreset="slideInBottom"
        colorScheme="white"
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={'gray.200'}
            background={'#1d5840'}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex>
              <Box p={2}>
                <BiSliderAlt />
              </Box>
              <Box p={2} pt={1} w={1200}>
                {selecteds.length > 0
                  ? 'Editar Novas Lojas'
                  : 'Criar Novas Lojas'}
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton onClick={clearForm} />
          <ModalBody bg="white" pt={0} py={4}>
            <FormControl isRequired>
              <Filter
                label="Loja"
                options={filterEdit.centers}
                isMulti={true}
                limit={1}
                isDisabled={selecteds.length > 0}
                value={paramsEdit.lojaIds}
                onChange={value =>
                  handleUpdateEditParams({ name: 'lojaIds', value: value })
                }
                isLoading={loadingEdit}
              />
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <SelectAsyncPaginateFromApiPost
                label="Produto"
                apiUrl="/v1/Produto"
                isDisabled={selecteds.length > 0}
                value={paramsEdit.produtoIds}
                isMulti={true}
                onChange={value =>
                  handleUpdateEditParams({ name: 'produtoIds', value: value })
                }
              />
            </FormControl>
            <br></br>
            <br></br>
            <FormControl isRequired>
              <FormLabel>Data Inicio</FormLabel>
              <Input
                borderBottomColor="black"
                type="date"
                value={paramsEdit.dataInicio}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'dataInicio',
                    value: value.target.value
                  })
                }
              ></Input>
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <FormLabel>Data Fim</FormLabel>
              <Input
                borderBottomColor="black"
                type="date"
                value={paramsEdit.dataFim}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'dataFim',
                    value: value.target.value
                  })
                }
              ></Input>
            </FormControl>
            <br></br>

            <br></br>
          </ModalBody>
          <ModalFooter
            bg="white"
            borderBottomLeftRadius={5}
            borderBottomRightRadius={5}
          >
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              bg="green.600"
              color="#fff"
              onClick={() => {
                if (selecteds.length > 0) {
                  updateDataCurve()
                  onClose()
                } else {
                  createData()
                  onClose()
                }
              }}
              isDisabled={paramsEdit.lojaIds.length === 0}
              _hover={{
                bg: 'green.500'
              }}
              _active={{
                bg: 'green.500'
              }}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ParametrizationCurveStoreCreate
